// @ts-nocheck

import React, { useState } from 'react';
import Input from 'antd/lib/input';






export default ({ handleBlur, value }) => {
  const [val, setValue] = useState(value);
  return (
    <Input
      value={val}
      onBlur={() => handleBlur(val)}
      onChange={(e) => setValue(e.target.value)} />);


};